import React from 'react';


export default function InputFile(props : any) {
  return <>
    <input hidden id={props.id} accept={props.accept} type="file"></input>
  </>
}